import React, { PropsWithChildren } from "react";
import { View } from "react-native";
import { AHQueryHandlerLoading } from "../AHQueryHandler";
import { AHWidget } from "./AHWidget";
import { AHWidgetTitle } from "./AHWidgetTitle";

export function AHWidgetLoading(props: PropsWithChildren<{ title?: string }>) {
  return (
    <AHWidget>
      <View style={{ position: "absolute" }}>
        <AHWidgetTitle>{props.title ?? ""}</AHWidgetTitle>
      </View>
      <AHQueryHandlerLoading />
    </AHWidget>
  );
}
